module.exports = __webpack_public_path__ + "media/images/logo-50830644569c58bdf08ff7030e4c025b.png";